import React, { useState, useEffect, useRef } from "react";
import { useAuth, db } from "../context/authContext";
import { collection, query, onSnapshot, doc, getDoc, updateDoc, where, orderBy, limit, setDoc } from "firebase/firestore";
import Reloj from "./Reloj.js";
import Calorias from "./Calorias.js";
import Distancia from "./Distancia.js";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useRPM } from "../hooks/useRPM";
import logo from "../assets/Logo.png";

// 🔹 Hooks nuevos
import { useSyncRPM } from "../hooks/useSyncRPM";

// 🔹 RTDB
import { rtdb } from "../firebase";
import { ref, onValue, remove, set } from "firebase/database";

// 🔹 Emojis disponibles
const EMOJIS_FAKE = ["❤️", "👍", "💪", "🚀", "👊", "💦", "🐘", "🏆", "👏", "🥵"];

// 🔹 Nombres fake (solo 4 usuarios)
const NOMBRES_FAKE = [
  "Sara", "Alex", "Ana", "Juan",
  "Elena"
];

export function Home() {
  const {
    logout,
    loading,
    EstadoLogout,
    addRanking,
    enviarEmoji,
    addInfoGym,
    darPropina,
    comprarTokens,
    user,
  } = useAuth();

  const navigate = useNavigate();

  const wakeLockRef = useRef(null);

  // 🔹 Detectar si volvemos a la clase desde Ranking o ResumenEntreno
  useEffect(() => {
    const internalNav = localStorage.getItem("internalNav");

    if (internalNav) {
      console.log("🔄 Volviendo a clase con internalNav → no reseteamos nada");
      localStorage.removeItem("internalNav"); // limpiar la marca
      return; // 👈 evitamos que se ejecute la lógica de reset
    }

    // ⚠️ Si NO venimos de internalNav, sigue la lógica normal (se ejecutarán los otros useEffect)
  }, []);

  useEffect(() => {
    const activarWakeLock = async () => {
      try {
        if ("wakeLock" in navigator && document.visibilityState === "visible") {
          wakeLockRef.current = await navigator.wakeLock.request("screen");
          console.log("🔆 Wake Lock activado");
        }
      } catch (err) {
        console.error("❌ No se pudo activar Wake Lock:", err);
      }
    };

    const reactivarWakeLock = async () => {
      if (
        document.visibilityState === "visible" &&
        "wakeLock" in navigator &&
        !wakeLockRef.current
      ) {
        await activarWakeLock();
      }
    };

    activarWakeLock();

    document.addEventListener("visibilitychange", reactivarWakeLock);

    return () => {
      document.removeEventListener("visibilitychange", reactivarWakeLock);

      if (wakeLockRef.current) {
        wakeLockRef.current.release().catch(() => { });
        wakeLockRef.current = null;
      }
    };
  }, []);


  // Estados
  const [mensajeError, setMensajeError] = useState("");
  const [personas, setPersonas] = useState([]);
  const [personasUser, setPersonasUser] = useState("");
  const [emojis, setEmojis] = useState("");
  const [puntosRanking, setPuntosRanking] = useState(0);
  const [rpmUsuarios, setRpmUsuarios] = useState({});
  const [estadoClase, setEstadoClase] = useState(null);
  const [customPropina, setCustomPropina] = useState("");
  const [isGym, setIsGym] = useState(true);
  const [tokens, setTokens] = useState(0);
  const [personasFake, setPersonasFake] = useState([]);
  const [lobbyActivo, setLobbyActivo] = useState(false);


  // Estados
  const [puntosSesion, setPuntosSesion] = useState(0);   // progreso al bonus
  const [puntosTotales, setPuntosTotales] = useState(0); // acumulado ranking
  const [puntosLocal, setPuntosLocal] = useState(0);     // en memoria (emojis)
  const [nombreUsuario, setNombreUsuario] = useState(""); // si no existe, añade
  const [nombreGym, setNombreGym] = useState("");
  const [claseNombre, setClaseNombre] = useState("");


  // Hook de RPM
  const { rpm, started, startDetection, stopDetection } = useRPM();

  const [energy, setEnergy] = useState(0);
  const energyRef = useRef(0);
  const energyColor =
    energy <= 200
      ? "text-green-400"
      : energy <= 500
        ? "text-yellow-400"
        : energy <= 750
          ? "text-orange-400"
          : "text-red-500";

  useEffect(() => {
    // Si no está pedaleando, la energía queda a 0
    if (rpm <= 5) {
      energyRef.current = 0;
      setEnergy(0);
      return;
    }

    // RPM mínimas y máximas que vamos a usar
    const MIN_RPM = 40;
    const MAX_RPM = 120;

    // Energía mínima y máxima
    const MIN_ENERGY = 150;
    const MAX_ENERGY = 1000;

    // Evita valores fuera del rango
    const rpmLimitada = Math.max(
      MIN_RPM,
      Math.min(MAX_RPM, rpm)
    );

    // Más RPM = menos energía
    // Menos RPM = más energía
    const porcentajeInverso =
      (MAX_RPM - rpmLimitada) / (MAX_RPM - MIN_RPM);

    const targetEnergy = Math.round(
      MIN_ENERGY +
      porcentajeInverso * (MAX_ENERGY - MIN_ENERGY)
    );

    // Suaviza los cambios para que no salte de golpe
    const nuevaEnergy = Math.round(
      energyRef.current * 0.9 + targetEnergy * 0.1
    );

    energyRef.current = nuevaEnergy;
    setEnergy(nuevaEnergy);
  }, [rpm]);

  //const energy = Math.max(0, Math.min(1000, Math.round((rpm / 120) * 1000)));

  // Enviar RPM en vivo → RTDB

  // 2️⃣ Llamar al hook con valores dinámicos
  // Enviar RPM en vivo → RTDB
  useSyncRPM(rpm, energy, started, nombreGym, claseNombre, nombreUsuario, estadoClase);

  // 2️⃣ buscar nombre usuario

  useEffect(() => {
    const nombreGuardado = JSON.parse(localStorage.getItem("nombre")) || "Anónimo";
    setNombreUsuario(nombreGuardado);
  }, []);


  // 3️⃣ Suscribirte al nodo correcto en RTDB

  // 🔹 Marcar usuario como activo al entrar en Home SOLO si el último contexto no era /comprobacion

  useEffect(() => {
    const activarUsuario = async () => {
      if (!user?.uid || !nombreGym || !claseNombre) return;

      try {
        const userRef = doc(db, "usuarios", user.uid);
        const snap = await getDoc(userRef);

        if (snap.exists()) {
          await updateDoc(userRef, {
            activo: true,
            ultimoContexto: "/home",
          });

          console.log("🟢 Usuario activo en Firestore + contexto /home");

          const rtdbRef = ref(
            rtdb,
            `clases/${nombreGym}/${claseNombre}/usuarios/${user.uid}`
          );

          const data = snap.data();

          await set(rtdbRef, {
            nombre: data.nombre || nombreUsuario || "Anónimo",
            rpm: 0,
            energy: 0,
            activo: true,
          });

          console.log("🟢 Usuario añadido en RTDB con rpm=0");
        }
      } catch (err) {
        console.error("❌ Error al activar usuario:", err);
      }
    };

    activarUsuario();
  }, [user?.uid, nombreGym, claseNombre, nombreUsuario]);


  // 2️⃣ Marcar inactivo al cerrar la pestaña
  useEffect(() => {
    const handleBeforeUnload = async () => {
      try {
        if (user?.uid) {
          const userRef = doc(db, "usuarios", user.uid);
          await updateDoc(userRef, { activo: false });
          console.log("🚪 Usuario marcado inactivo al cerrar Home");
        }
      } catch (err) {
        console.error("❌ Error al marcar inactivo en Home:", err);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [user]);

  useEffect(() => {
    if (!started) {
      setModalMessage("⚡ Activa sensores para empezar a pedalear 🚴‍♂️");
      setModalType("success");
      setModalOpen(true);
    }
  }, [started]);

  const syncPuntos = async () => {
    try {
      if (!user?.uid) return;

      const fecha = new Date();
      const nombreMes = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(fecha);
      const mesHoy = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);

      const rankingRef = doc(db, "config", "rankingMensual");
      const rankingSnap = await getDoc(rankingRef);

      let mesActivo = mesHoy;

      if (!rankingSnap.exists()) {
        await setDoc(rankingRef, {
          mesActivo: mesHoy,
          updatedAt: Date.now(),
        });
        mesActivo = mesHoy;
      } else {
        const rankingData = rankingSnap.data();

        if (rankingData.mesActivo !== mesHoy) {
          await setDoc(
            rankingRef,
            {
              mesActivo: mesHoy,
              updatedAt: Date.now(),
            },
            { merge: true }
          );
          mesActivo = mesHoy;
        } else {
          mesActivo = rankingData.mesActivo || mesHoy;
        }
      }

      const userRef = doc(db, "usuarios", user.uid);
      const snap = await getDoc(userRef);
      const data = snap.exists() ? snap.data() : {};

      const mismoMes = data.mesReseteado === mesActivo;

      const baseTotales = mismoMes ? (data.puntosTotales || 0) : 0;
      const baseSesion = mismoMes ? (puntosSesion || 0) : 0;

      const nuevosTotales = baseTotales + puntosLocal;
      const nuevaSesion = baseSesion + puntosLocal;

      const totalesRedondeados = Math.floor(nuevosTotales);
      const sesionRedondeada = Math.floor(nuevaSesion);

      await updateDoc(userRef, {
        puntosTotales: totalesRedondeados,
        puntosSesion: sesionRedondeada,
        mesReseteado: mesActivo,
      });

      setPuntosTotales(totalesRedondeados);
      setPuntosSesion(sesionRedondeada);
      setPuntosLocal(0);

      console.log(
        `✅ Sync → Mes: ${mesActivo}, Sesión: ${sesionRedondeada}, Totales: ${totalesRedondeados}`
      );
    } catch (err) {
      console.error("❌ Error al sincronizar puntos:", err);
    }
  };

  // Validar que cambio de dia y toca volver a pagar token

  useEffect(() => {
    const validarSesion = async () => {
      if (!user?.uid) return;        // 👈 si no hay usuario, nada

      const userRef = doc(db, "usuarios", user.uid);
      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) return;

      const data = userSnap.data();
      const hoy = new Date().toISOString().split("T")[0];

      // ⚡ Solo validamos por fecha
      if (data.ultimoAcceso && data.ultimoAcceso !== hoy) {
        console.warn("⚠️ Día distinto, requiere comprobación");
        navigate("/comprobacion");
        return;
      }

      console.log("✅ Sesión validada (solo fecha):", { ultimoAcceso: data.ultimoAcceso });
    };

    validarSesion();
  }, [user, navigate]);

  //Validar que estoy en home

  useEffect(() => {
    localStorage.setItem("lastPage", "home");
  }, []);

  // Guardar contexto en Firestore → "/home"
  useEffect(() => {
    if (!user?.uid) return;

    const userRef = doc(db, "usuarios", user.uid);
    updateDoc(userRef, { ultimoContexto: "/home" })
      .then(() => console.log("📝 Contexto guardado en Firestore: /home"))
      .catch(err => console.error("❌ Error guardando contexto:", err));
  }, [user]);


  // 👉 Handlers

  // 🔹 Emojis
  const EMOJIS = ["❤️", "👍", "💪", "🚀", "👊", "💦", "🐘", "🏆", "👏", "🥵"];

  const handleEmoji = async (icon) => {
    try {
      setEmojis(icon);
      setTimeout(() => setEmojis(""), 5000);

      // 👇 Incrementar contador de emojis lanzados
      setPuntosRanking((prev) => prev + 1);

      setPuntosLocal((prev) => {
        // ➕ ahora suma 0.1 puntos en lugar de 1
        const nuevosLocal = parseFloat((prev + 0.1).toFixed(1));
        const totalSesion = parseFloat((puntosSesion + nuevosLocal).toFixed(1));

        if (totalSesion > 0 && Math.round(totalSesion) % 1000 === 0) {
          checkBonus(totalSesion);
        } else {
          console.log("👉 Local:", nuevosLocal, "Total sesión:", totalSesion);
        }

        return nuevosLocal;
      });

      // 👉 🔥 Enviar emoji a Firebase para que lo vean los demás

      await enviarEmoji(icon);

    } catch (err) {
      console.error("Error en handleEmoji:", err);
    }
  };

  // 🎁 Control de último bonus con useRef
  const lastBonusGivenRef = React.useRef(0);

  const checkBonus = async (puntosTotalesSesion) => {
    const totalEntero = Math.floor(puntosTotalesSesion);
    const umbral = Math.floor(totalEntero / 1000) * 1000;

    if (umbral > 0 && umbral !== lastBonusGivenRef.current) {
      lastBonusGivenRef.current = umbral;

      try {
        if (!isGym) {
          // Solo usuarios fuera de gym reciben tokens
          await comprarTokens(user.uid, 1, { metodo: "bonus" });
          console.log("🎁 BONUS con token en:", umbral);

          setModalType("success");
          setModalMessage(`🎉 ¡Has ganado 1 token extra por alcanzar ${umbral} puntos!`);
        } else {
          // En gym: solo mostrar mensaje, no sumar token
          console.log("🎉 BONUS alcanzado en gym (sin token):", umbral);

          setModalType("success");
          setModalMessage(`🚴 ¡Enhorabuena, has alcanzado ${umbral} puntos!
                👉 Tus puntos cuentan para el ranking, sigue pedaleando 💪`);

        }

        setModalOpen(true);
      } catch (err) {
        console.error("❌ Error en checkBonus acumulativo:", err);
      }
    }
  };





  const handleLogout = async () => {
    try {
      if (user?.uid && nombreGym && claseNombre) {
        // 🔥 Borrar nodo RTDB al salir explícitamente
        const userRef = ref(rtdb, `clases/${nombreGym}/${claseNombre}/usuarios/${user.uid}`);
        await remove(userRef);
        console.log("🧹 Nodo RTDB del usuario eliminado al hacer logout");
      }

      if (user?.uid) {
        await syncPuntos();
        const userRef = doc(db, "usuarios", user.uid);
        await updateDoc(userRef, { puntosSesion: 0 });
        await addRanking();
        await EstadoLogout();
      }

      setPuntosSesion(0);
      setPuntosLocal(0);
      stopDetection();
      localStorage.removeItem("gimnasio");
      localStorage.setItem("logout", Date.now());

      await logout();
      console.log("✅ Logout completo y sincronizado");
    } catch (err) {
      console.error("❌ Error en logout:", err);
    }
  };


  const guardarEntrenoAutomaticamente = () => {
    try {
      const claseId = claseNombre;
      const gimnasio = nombreGym;

      const puntosEntreno = Math.floor(
        puntosSesion + puntosLocal
      );

      const duracion =
        document.getElementById("reloj-duracion")
          ?.innerText || "00:00";

      const distancia =
        document.getElementById("distancia-recorrido")
          ?.innerText || "0 Km";

      const calorias =
        document.getElementById("calorias-gastadas")
          ?.innerText || "0 Kcal";

      // No guardar sesiones completamente vacías
      const sesionVacia =
        puntosEntreno <= 0 &&
        rpm <= 0 &&
        duracion === "00:00";

      if (sesionVacia) {
        console.log(
          "ℹ️ Sesión vacía: no se guarda en el historial"
        );

        return false;
      }

      const nuevoEntreno = {
        fecha: new Date().toLocaleDateString(),
        duracion,
        distancia,
        calorias,
        cadenciaMedia: rpm,
        emojis: puntosRanking,
        puntos: puntosEntreno,
        modo: "Premium",
        claseId,
        gimnasio,
      };

      const entrenos =
        JSON.parse(
          localStorage.getItem("historialEntrenos") ||
          "[]"
        ) || [];

      // Evitar guardar dos veces la misma sesión
      const yaExiste = entrenos.some(
        (entreno) =>
          entreno.fecha === nuevoEntreno.fecha &&
          entreno.claseId === nuevoEntreno.claseId &&
          entreno.gimnasio === nuevoEntreno.gimnasio
      );

      if (yaExiste) {
        console.log(
          "ℹ️ El entrenamiento ya estaba guardado"
        );

        return false;
      }

      entrenos.push(nuevoEntreno);

      localStorage.setItem(
        "historialEntrenos",
        JSON.stringify(entrenos)
      );

      console.log(
        "✅ Entrenamiento guardado automáticamente",
        nuevoEntreno
      );

      return true;
    } catch (error) {
      console.error(
        "❌ Error guardando automáticamente el entreno:",
        error
      );

      return false;
    }
  };

  const handleGuardar = async () => {
    try {
      // Guardar primero, antes de poner puntos a cero
      const guardado =
        guardarEntrenoAutomaticamente();

      if (!guardado) {
        setModalType("error");
        setModalMessage(
          "⚠️ Este entreno ya fue guardado o todavía está vacío."
        );
        setModalOpen(true);
        return;
      }

      await syncPuntos();

      if (user?.uid) {
        const userRef = doc(
          db,
          "usuarios",
          user.uid
        );

        await updateDoc(userRef, {
          puntosSesion: 0,
        });
      }

      setPuntosSesion(0);
      setPuntosLocal(0);

      await addRanking();

      navigate("/resumentreno");
    } catch (error) {
      console.error(
        "❌ Error al guardar entreno:",
        error
      );

      setModalType("error");
      setModalMessage(
        "❌ Error al guardar el entreno."
      );
      setModalOpen(true);
    }
  };


  const handleRanking = async () => {
    try {
      await syncPuntos(); // 👈 añadimos aquí
      // Reset de puntos aquí
      const userRef = doc(db, "usuarios", user.uid);
      await updateDoc(userRef, { puntosSesion: 0 });
      setPuntosSesion(0);
      setPuntosLocal(0);

      await addRanking();

      navigate("/Ranking", {
        state: { tipoRanking: "grupo" },
      });

    } catch { }
  };

  const handleCerrarClase = async () => {
    try {
      // 1. Guardar el entreno antes de limpiar los puntos
      guardarEntrenoAutomaticamente();

      // 2. Detener sensores inmediatamente
      stopDetection();

      // Guardar estos datos antes de limpiar localStorage
      const uid = user?.uid;
      const gymActual = nombreGym;
      const claseActual = claseNombre;

      // 3. Limpiar almacenamiento local
      localStorage.removeItem("gimnasio");
      localStorage.removeItem("claseId");
      localStorage.setItem("cerrarClase", Date.now());

      // 4. Volver al listado inmediatamente
      navigate("/comprobacion");

      // 5. Continuar la sincronización sin bloquear la pantalla
      try {
        // Eliminar usuario de RTDB
        if (uid && gymActual && claseActual) {
          const usuarioRtdbRef = ref(
            rtdb,
            `clases/${gymActual}/${claseActual}/usuarios/${uid}`
          );

          await remove(usuarioRtdbRef);

          console.log(
            "🧹 Nodo RTDB del usuario eliminado al cerrar clase"
          );
        }

        // Guardar puntos antes de poner la sesión a cero
        await syncPuntos();

        if (uid) {
          const usuarioFirestoreRef = doc(
            db,
            "usuarios",
            uid
          );

          await updateDoc(usuarioFirestoreRef, {
            puntosSesion: 0,
            activo: false,
          });
        }

        await addRanking();
        await addInfoGym("", "");
        await EstadoLogout();

        console.log(
          "✅ Salida de clase completada y sincronizada"
        );
      } catch (errorSincronizacion) {
        console.error(
          "❌ Se salió de la clase, pero falló parte de la sincronización:",
          errorSincronizacion
        );
      }
    } catch (err) {
      console.error("❌ Error al cerrar clase:", err);

      setModalType("error");
      setModalMessage(
        "❌ No se pudo salir de la clase. Inténtalo de nuevo."
      );
      setModalOpen(true);
    }
  };


  // Estados nuevos
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success"); // "success" | "error"

  const handlePropina = async (cantidad) => {
    try {
      const claseId = nombreGym;

      if (!claseId) {
        setModalType("error");
        setModalMessage("⚠️ No hay canal/gimnasio seleccionado.");
        setModalOpen(true);
        return;
      }

      const userRef = doc(db, "usuarios", user.uid);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.exists() ? userSnap.data() : {};
      const nombre = userData.nombre || nombreUsuario || "Usuario";

      const ok = await darPropina(user.uid, claseId, cantidad, nombre);
      if (ok) {
        setModalType("success");
        setModalMessage(`🎉 Has dado ${cantidad} tokens de propina`);
      } else {
        setModalType("error");
        setModalMessage("❌ No tienes suficientes tokens");
      }
      setCustomPropina("");
      setModalOpen(true);
    } catch (err) {
      console.error("❌ Error al dar propina:", err);
      setModalType("error");
      setModalMessage("❌ Error al procesar la propina.");
      setModalOpen(true);
    }
  };

  // ------------------ EFFECTS ------------------


  // 🔹 Reaccionar a cambios en estadoClase + lobbyActivo
  useEffect(() => {
    if (estadoClase !== "cerrada") return;

    // Clase cerrada, pero el lobby continúa activo:
    // el usuario permanece esperando.
    if (lobbyActivo) {
      setModalType("success");
      setModalMessage(
        "⏳ La clase está cerrada por ahora. El lobby está activo, espera a que el instructor abra la clase 🚴‍♂️"
      );
      setModalOpen(true);
      return;
    }

    // Clase cerrada y lobby cerrado:
    // limpiar completamente al usuario.
    const sacarUsuarioDeLaClase = async () => {
      try {
        // 1. Guardar el entreno antes de limpiar puntos
        guardarEntrenoAutomaticamente();

        // 2. Detener sensores para que no se sigan enviando RPM
        stopDetection();

        // 3. Guardar los puntos antes de salir
        await syncPuntos();

        // 4. Eliminar el usuario de Realtime Database
        if (user?.uid && nombreGym && claseNombre) {
          const usuarioRtdbRef = ref(
            rtdb,
            `clases/${nombreGym}/${claseNombre}/usuarios/${user.uid}`
          );

          await remove(usuarioRtdbRef);

          console.log(
            "🧹 Usuario eliminado de RTDB al cerrarse la clase"
          );
        }

        // 5. Marcar usuario inactivo y limpiar su clase en Firestore
        if (user?.uid) {
          const usuarioFirestoreRef = doc(
            db,
            "usuarios",
            user.uid
          );

          await updateDoc(usuarioFirestoreRef, {
            activo: false,
            nombreGym: "",
            claseId: "",
            ultimoContexto: "/comprobacion",
            puntosSesion: 0,
          });

          console.log(
            "🔴 Usuario inactivo y clase limpiada en Firestore"
          );
        }

        // 6. Limpiar almacenamiento local
        localStorage.removeItem("gimnasio");
        localStorage.removeItem("claseId");

        // 7. Limpiar estados locales
        setPuntosSesion(0);
        setPuntosLocal(0);

        setModalType("success");
        setModalMessage(
          "✅ La clase ha terminado y tu entreno se ha guardado automáticamente."
        );
        setModalOpen(true);

        // 8. Redirigir
        setTimeout(() => {
          navigate("/comprobacion");
        }, 2500);
      } catch (err) {
        console.error(
          "❌ Error limpiando usuario al cerrar la clase:",
          err
        );
      }
    };

    sacarUsuarioDeLaClase();
  }, [
    estadoClase,
    lobbyActivo,
    user?.uid,
    nombreGym,
    claseNombre,
    navigate,
  ]);

  // 🔹 Suscripción Firestore → cambios en claseId dentro de Claves/{gymId}
  useEffect(() => {
    const gimnasioGuardado = JSON.parse(localStorage.getItem("gimnasio"));
    if (!gimnasioGuardado) return;

    const estadoRef = doc(db, "claves", gimnasioGuardado);

    const unsubscribe = onSnapshot(estadoRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();

        // Estado de la clase
        setEstadoClase(data.estado?.toLowerCase() || "cerrada");
        setIsGym(data.isGym ?? true);
        setLobbyActivo(data.lobbyActivo ?? false);
        setNombreGym(data.nombre || "Mi Gimnasio");

        // ⚡ si cambia el claseId (nombre de la clase), lo actualizamos
        if (data.claseId) {
          setClaseNombre(data.claseId);
        }
      }
    });

    return () => unsubscribe();
  }, []);


  // Suscripción Firestore (usuarios en vivo)
  useEffect(() => {
    const gimnasioGuardado = JSON.parse(localStorage.getItem("gimnasio"));
    const userSinGym = JSON.parse(localStorage.getItem("usuario"));
    // const userSinGym = JSON.parse(localStorage.getItem("user.uid")); esto no pongas porque sale Yo si lo pones en vez del nombre Chris

    const nombre = JSON.parse(localStorage.getItem("nombre"));

    if (!gimnasioGuardado || !userSinGym) return;

    const q = query(collection(db, "usuarios"));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const personasActivasEnGimnasio = snapshot.docs
          .map((doc) => doc.data())
          .filter(
            (p) =>
              p.activo &&
              p.nombreGym === gimnasioGuardado &&
              p.uidd !== userSinGym
          )
          .map((p) => ({
            uid: p.uidd,
            nombre: p.nombre,
            mensaje: p.mensajes,
            puntos: p.puntosTotales || 0
          }));

        setPersonas(personasActivasEnGimnasio);
        setPersonasUser(nombre);
      },
      () => setMensajeError("⚠️ No se pudo cargar la lista de usuarios.")
    );

    return () => unsubscribe();
  }, []);

  // 🔹 Inicializar usuarios fake cuando no es Gym
  useEffect(() => {
    if (!isGym) {
      const inicial = NOMBRES_FAKE.map((nombre) => ({
        nombre,
        rpm: Math.floor(Math.random() * 40) + 60,
        emojiActivo: null,
      }));
      setPersonasFake(inicial);
    }
  }, [isGym]);

  // 🔹 Actualizar fake cada 8s
  useEffect(() => {
    if (!isGym) {
      const interval = setInterval(() => {
        setPersonasFake((prev) =>
          prev.map((p) => {
            const nuevaRpm = Math.floor(Math.random() * 40) + 60;
            const lanzarEmoji = Math.random() < 0.4;
            const emojiRandom = lanzarEmoji
              ? EMOJIS_FAKE[Math.floor(Math.random() * EMOJIS_FAKE.length)]
              : null;
            return { ...p, rpm: nuevaRpm, emojiActivo: emojiRandom };
          })
        );

        // 🔹 resetear emoji después de 5s
        setTimeout(() => {
          setPersonasFake((prev) => prev.map((p) => ({ ...p, emojiActivo: null })));
        }, 5000);
      }, 8000);

      return () => clearInterval(interval);
    }
  }, [isGym]);




  // 🔹 Suscripción Firestore → tokens en vivo
  useEffect(() => {
    if (!user?.uid) return;
    const userRef = doc(db, "usuarios", user.uid);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        setTokens(snapshot.data().tokens || 0);
        localStorage.setItem("Tokens", snapshot.data().tokens || 0);
      }
    });
    return () => unsubscribe();
  }, [user]);


  // 🔹 Cargar puntos iniciales SOLO una vez

  useEffect(() => {
    const fetchInitial = async () => {
      if (!user?.uid) return;

      const fecha = new Date();
      const nombreMes = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(fecha);
      const mesHoy = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);

      const rankingRef = doc(db, "config", "rankingMensual");
      const rankingSnap = await getDoc(rankingRef);

      let mesActivo = mesHoy;

      if (!rankingSnap.exists()) {
        await setDoc(rankingRef, {
          mesActivo: mesHoy,
          updatedAt: Date.now(),
        });
        mesActivo = mesHoy;
      } else {
        const rankingData = rankingSnap.data();
        mesActivo = rankingData?.mesActivo || mesHoy;
      }

      const userRef = doc(db, "usuarios", user.uid);
      const snap = await getDoc(userRef);

      if (snap.exists()) {
        const data = snap.data();

        const mismoMes = data.mesReseteado === mesActivo;
        const sesion = mismoMes ? (data.puntosSesion || 0) : 0;
        const totales = mismoMes ? (data.puntosTotales || 0) : 0;

        setPuntosSesion(sesion);
        setPuntosTotales(totales);

        localStorage.setItem("PuntosSesion", sesion);
        localStorage.setItem("PuntosTotales", totales);

        console.log("🔥 Puntos iniciales cargados:", { mesActivo, sesion, totales });
      }
    };

    fetchInitial();
  }, [user]);


  // 🔹 Efecto para sumar puntos automáticamente cada 5 minutos en base a RPM

  useEffect(() => {
    if (!started) return;

    const interval = setInterval(() => {
      if (rpm > 5) {
        // Ejemplo: 80 RPM = 8 puntos cada 10 segundos
        const puntosGanados = Math.max(1, Math.floor(rpm / 10));

        setPuntosLocal((prev) => {
          const nuevosLocal = prev + puntosGanados;
          const totalSesion = puntosSesion + nuevosLocal;

          console.log(
            `⏱️ AutoPuntos: +${puntosGanados} (RPM=${rpm}) → Sesión=${totalSesion}`
          );

          checkBonus(totalSesion);

          return nuevosLocal;
        });
      }
    }, 10 * 1000); // cada 10 segundos

    return () => clearInterval(interval);
  }, [started, rpm, puntosSesion]);

  const [propinaAnimada, setPropinaAnimada] = useState(null);

  useEffect(() => {
    const gimnasioGuardado = JSON.parse(localStorage.getItem("gimnasio"));
    if (!gimnasioGuardado) return;

    const q = query(
      collection(db, "propinas"),
      where("claseId", "==", gimnasioGuardado),
      orderBy("timestamp", "desc"),
      limit(1) // 👈 solo la más reciente
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const ultima = snapshot.docs[0].data();
        console.log("💸 Última propina (orderby):", ultima);

        setPropinaAnimada(ultima);

        // se borra sola después de 5 s
        setTimeout(() => setPropinaAnimada(null), 5000);
      }
    });

    return () => unsubscribe();
  }, []);

  // ----Si la clase se cierra y se vuelve a abrir puntos a cero ------------------

  useEffect(() => {
    if (estadoClase === "abierta") {
      setPuntosSesion(0);
      setPuntosLocal(0);

      if (user?.uid) {
        const userRef = doc(db, "usuarios", user.uid);
        updateDoc(userRef, { puntosSesion: 0 });
      }

      console.log("🚀 Nueva clase abierta → contador reiniciado");
    }
  }, [estadoClase, user]);


  // ------------------ RENDER ------------------

  if (loading) {
    return (
      <div className="w-screen min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto rounded-full border-4 border-white/10 border-t-yellow-400 animate-spin" />

          <p className="mt-4 text-sm text-gray-400">
            Cargando tu clase...
          </p>
        </div>
      </div>
    );
  }

  const puntosActuales = Math.floor(puntosSesion + puntosLocal);
  const puntosBonus = puntosActuales % 1000;

  const porcentajeBonus =
    (puntosBonus / 1000) * 100;

  const puntosRestantes =
    puntosBonus === 0
      ? 1000
      : 1000 - puntosBonus;

  const claseAbierta =
    estadoClase === "abierta";

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
      <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">

        {/* CABECERA */}
        <div className="mb-5">
          <div className="flex items-center justify-between gap-3">
            <img
              src={logo}
              alt="RPM Coach"
              className="w-28 h-auto"
            />

            <motion.button
              type="button"
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate("/comprar-tokens")}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-yellow-400/20 bg-yellow-400/10 text-sm font-bold text-yellow-300 shadow-lg"
            >
              <span>🎟️</span>
              <span>{tokens}</span>
              <span className="text-yellow-200">+</span>
            </motion.button>
          </div>

          <div className="mt-4 p-4 rounded-3xl border border-white/10 bg-white/10 shadow-xl backdrop-blur-lg">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-xs uppercase tracking-widest text-gray-400">
                  Clase actual
                </p>

                <h1 className="mt-1 text-lg font-extrabold text-white truncate">
                  {nombreGym || "RPM Coach"}
                </h1>

                <p className="mt-1 text-sm text-gray-400 truncate">
                  {claseNombre || "Sesión de ciclismo"}
                </p>
              </div>

              <div
                className={`shrink-0 px-3 py-2 rounded-full border text-xs font-bold ${claseAbierta
                  ? "border-green-400/20 bg-green-500/10 text-green-400"
                  : "border-red-400/20 bg-red-500/10 text-red-400"
                  }`}
              >
                <span
                  className={`inline-block w-2 h-2 mr-2 rounded-full ${claseAbierta
                    ? "bg-green-400"
                    : "bg-red-400"
                    }`}
                />

                {claseAbierta
                  ? "EN DIRECTO"
                  : "CERRADA"}
              </div>
            </div>
          </div>
        </div>

        {/* PROGRESO DE PUNTOS */}
        <div className="mb-5 p-5 rounded-3xl border border-green-400/20 bg-green-500/10 shadow-xl">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-green-300">
                Próxima recompensa
              </p>

              <p className="mt-1 text-2xl font-extrabold text-white">
                {puntosActuales} puntos
              </p>

              <p className="mt-1 text-sm text-gray-300">
                Te faltan{" "}
                <span className="font-bold text-green-300">
                  {puntosRestantes}
                </span>{" "}
                para tu bonus.
              </p>
            </div>

            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-green-500/20 text-2xl">
              🏆
            </div>
          </div>

          <div className="mt-4 w-full h-3 rounded-full bg-black/30 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{
                width: `${porcentajeBonus}%`,
              }}
              transition={{ duration: 0.4 }}
              className="h-full rounded-full bg-gradient-to-r from-green-400 to-emerald-500"
            />
          </div>

          <div className="mt-2 flex justify-between text-xs text-gray-400">
            <span>{puntosBonus} / 1000</span>
            <span>Bonus</span>
          </div>
        </div>

        {/* MÉTRICAS */}
        <div className="grid grid-cols-3 gap-2 mb-5">
          <div className="px-2 py-4 rounded-2xl border border-white/10 bg-white/10 text-center shadow-lg">
            <p className="mb-2 text-lg">⏱️</p>

            <div
              id="reloj-duracion"
              className="text-lg font-extrabold text-white"
            >
              <Reloj />
            </div>

            <p className="mt-1 text-xs text-gray-400">
              Duración
            </p>
          </div>

          <div className="px-2 py-4 rounded-2xl border border-white/10 bg-white/10 text-center shadow-lg">
            <p className="mb-2 text-lg">🚴</p>

            <div
              id="distancia-recorrido"
              className="text-lg font-extrabold text-blue-400"
            >
              <Distancia rpm={rpm} />
            </div>

            <p className="mt-1 text-xs text-gray-400">
              Distancia
            </p>
          </div>

          <div className="px-2 py-4 rounded-2xl border border-white/10 bg-white/10 text-center shadow-lg">
            <p className="mb-2 text-lg">🔥</p>

            <div
              id="calorias-gastadas"
              className="text-lg font-extrabold text-orange-400"
            >
              <Calorias rpm={rpm} />
            </div>

            <p className="mt-1 text-xs text-gray-400">
              Calorías
            </p>
          </div>
        </div>

        {/* CARGA Y RPM */}
        <div className="relative mb-5 overflow-hidden rounded-3xl border border-white/10 bg-white/10 p-5 shadow-2xl backdrop-blur-lg">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-400">
                Rendimiento en vivo
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Carga estimada
              </h2>
            </div>

            <span className="px-3 py-1.5 rounded-full border border-white/10 bg-black/20 text-xs text-gray-300">
              {personasUser || "Yo"}
            </span>
          </div>

          <div className="mt-5 flex justify-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              className="relative w-56 h-56 flex flex-col items-center justify-center rounded-full border-8 border-white/10 bg-black/20 shadow-2xl"
            >
              <p
                className={`text-6xl font-extrabold ${energyColor}`}
              >
                {energy}
              </p>

              <p className="mt-1 text-xs uppercase tracking-widest text-gray-400">
                Carga estimada
              </p>

              <div className="mt-4 flex items-end gap-1.5 px-4 py-2 rounded-full border border-white/10 bg-white/10">
                <span className="text-2xl font-extrabold">
                  {rpm}
                </span>

                <span className="pb-1 text-xs text-gray-400">
                  RPM
                </span>
              </div>

              {/* Emoji enviado */}
              {emojis && (
                <motion.div
                  key={emojis}
                  initial={{
                    opacity: 0,
                    scale: 0.4,
                    y: 20,
                  }}
                  animate={{
                    opacity: 1,
                    scale: 1.3,
                    y: -45,
                  }}
                  transition={{ duration: 0.55 }}
                  className="absolute z-20 text-6xl pointer-events-none"
                >
                  {emojis}
                </motion.div>
              )}

              {/* Propina recibida */}
              {propinaAnimada && (
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 20,
                    scale: 0.9,
                  }}
                  animate={{
                    opacity: 1,
                    y: 0,
                    scale: 1,
                  }}
                  className="absolute z-30 -bottom-20 w-72 px-4 py-3 rounded-2xl border border-yellow-400/20 bg-gray-900 text-center shadow-2xl"
                >
                  <p className="text-sm font-bold text-yellow-300">
                    🔥 {propinaAnimada.nombreUsuario} apoyó al
                    instructor con {propinaAnimada.cantidad} 🎟️
                  </p>
                </motion.div>
              )}
            </motion.div>
          </div>

          <p className="mt-10 text-center text-xs text-gray-400">
            Mantén la pantalla encendida para actualizar tus RPM.
          </p>
        </div>

        {/* ACTIVAR SENSORES */}
        {!started && (
          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            onClick={startDetection}
            className="w-full mb-5 flex items-center justify-between gap-3 px-4 py-3 rounded-2xl border border-blue-400/20 bg-blue-500/10 text-left shadow-lg"
          >
            <div>
              <p className="text-sm font-bold text-blue-300">
                Activa los sensores
              </p>

              <p className="mt-1 text-xs text-gray-400">
                Necesarios para detectar tus RPM.
              </p>
            </div>

            <span className="px-4 py-2 rounded-xl bg-blue-500 text-xs font-bold text-white">
              Activar
            </span>
          </motion.button>
        )}

        {/* REACCIONES */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-400">
                Reacciones
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Envía energía al grupo
              </h2>
            </div>

            <span className="text-xs text-gray-400">
              Desliza
            </span>
          </div>

          <div className="flex gap-3 overflow-x-auto px-2 py-3 rounded-3xl border border-white/10 bg-white/10 scroll-smooth snap-x snap-mandatory no-scrollbar">
            {[
              "❤️",
              "🔥",
              "💪",
              "🦵",
              "🦿",
              "👏",
              "🚀",
              "👍",
              "🏆",
              "🥵",
              "⚡",
              "👊",
              "💦",
              "🐘",
              "😈",
              "🤟",
              "🙌",
              "😮‍💨",
              "🫶",
              "🚴",
              "🎉",
              "⭐",
              "🤩",
              "💥",
              "✅",
              "😎",
            ].map((icon) => (
              <motion.button
                key={icon}
                type="button"
                whileTap={{ scale: 0.8 }}
                onClick={() => handleEmoji(icon)}
                className="min-w-[64px] w-[64px] h-[64px] shrink-0 flex items-center justify-center rounded-full border border-white/10 bg-white/10 text-3xl shadow-md snap-center active:bg-white/20"
              >
                {icon}
              </motion.button>
            ))}
          </div>
        </div>

        {/* ERROR */}
        {mensajeError && (
          <div className="mb-5 px-4 py-3 rounded-2xl border border-red-400/20 bg-red-500/10 text-sm font-semibold text-red-300">
            {mensajeError}
          </div>
        )}

        {/* PROPINAS */}
        <div className="mb-6">
          <div className="relative overflow-hidden rounded-3xl border border-yellow-400/20 bg-gradient-to-br from-yellow-500/20 via-orange-500/10 to-white/10 p-5 shadow-xl">
            <div className="flex items-start justify-between gap-4 mb-5">
              <div>
                <p className="text-xs uppercase tracking-widest text-yellow-300">
                  Apoya la clase
                </p>

                <h2 className="mt-1 text-lg font-extrabold">
                  ¿Te está motivando el instructor?
                </h2>

                <p className="mt-1 text-sm text-gray-300">
                  Envíale una propina y reconoce su esfuerzo.
                </p>
              </div>

              <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-2xl bg-yellow-400/20 text-2xl">
                🙌
              </div>
            </div>

            <div className="mb-4 flex items-center justify-between px-4 py-3 rounded-2xl border border-white/10 bg-black/20">
              <span className="text-sm text-gray-300">
                Saldo disponible
              </span>

              <span className="font-bold text-yellow-300">
                {tokens} 🎟️
              </span>
            </div>

            <div className="grid grid-cols-3 gap-3">
              {[1, 5, 10].map((cantidad) => (
                <motion.button
                  key={cantidad}
                  type="button"
                  whileTap={{ scale: 0.94 }}
                  onClick={() => handlePropina(cantidad)}
                  disabled={tokens < cantidad}
                  className="flex flex-col items-center justify-center py-3 rounded-2xl border border-yellow-400/20 bg-yellow-500/10 text-yellow-200 shadow-md disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <span className="text-lg font-extrabold">
                    {cantidad} 🎟️
                  </span>

                  <span className="mt-1 text-xs text-yellow-100">
                    {cantidad === 1
                      ? "Buen trabajo"
                      : cantidad === 5
                        ? "Gran clase"
                        : "Clase brutal"}
                  </span>
                </motion.button>
              ))}
            </div>

            <div className="mt-4 flex items-center gap-2">
              <input
                type="number"
                min="1"
                max={tokens}
                inputMode="numeric"
                placeholder="Otra cantidad"
                value={customPropina}
                onChange={(e) =>
                  setCustomPropina(e.target.value)
                }
                className="min-w-0 flex-1 px-4 py-3 rounded-xl border border-white/10 bg-black/20 text-white placeholder-gray-500 outline-none focus:border-yellow-400"
              />

              <motion.button
                type="button"
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  const cantidad =
                    Number(customPropina);

                  if (
                    !Number.isInteger(cantidad) ||
                    cantidad < 1
                  ) {
                    setModalType("error");
                    setModalMessage(
                      "⚠️ Introduce una cantidad válida."
                    );
                    setModalOpen(true);
                    return;
                  }

                  handlePropina(cantidad);
                }}
                disabled={
                  !customPropina ||
                  Number(customPropina) < 1
                }
                className="shrink-0 px-5 py-3 rounded-xl bg-gradient-to-r from-yellow-400 to-orange-500 font-bold text-black shadow-lg disabled:opacity-40 disabled:cursor-not-allowed"
              >
                Enviar
              </motion.button>
            </div>

            <p className="mt-3 text-center text-xs text-gray-400">
              La propina se descuenta de tus tokens.
            </p>
          </div>
        </div>

        {/* ACCIONES */}
        <div className="mb-6">
          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            onClick={handleGuardar}
            className="w-full py-4 rounded-2xl bg-gradient-to-r from-green-400 to-emerald-600 text-white font-extrabold shadow-xl"
          >
            ✅ Guardar entreno
          </motion.button>

          <div className="grid grid-cols-2 gap-3 mt-3">
            <motion.button
              type="button"
              whileTap={{ scale: 0.97 }}
              onClick={handleRanking}
              className="py-4 rounded-2xl border border-blue-400/20 bg-blue-500/10 text-blue-300 font-bold shadow-lg"
            >
              🏆 Ranking
            </motion.button>

            <motion.button
              type="button"
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate("/historial")}
              className="py-4 rounded-2xl border border-purple-400/20 bg-purple-500/10 text-purple-300 font-bold shadow-lg"
            >
              📊 Historial
            </motion.button>
          </div>

          <div className="mt-5 p-4 rounded-3xl border border-white/10 bg-white/5">
            <p className="mb-3 text-xs uppercase tracking-widest text-gray-500">
              Sesión
            </p>

            <motion.button
              type="button"
              whileTap={{ scale: 0.98 }}
              onClick={handleCerrarClase}
              className="w-full py-3 rounded-xl border border-orange-400/20 bg-orange-500/10 text-orange-300 font-bold"
            >
              🚪 Salir de la clase
            </motion.button>

            <button
              type="button"
              onClick={handleLogout}
              className="w-full mt-2 py-3 text-sm font-semibold text-red-400"
            >
              Cerrar sesión
            </button>
          </div>
        </div>

        {/* MODAL */}
        {modalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm">
            <motion.div
              initial={{
                opacity: 0,
                scale: 0.9,
                y: 15,
              }}
              animate={{
                opacity: 1,
                scale: 1,
                y: 0,
              }}
              className="w-full max-w-sm p-6 rounded-3xl border border-white/10 bg-gray-900 text-center shadow-2xl"
            >
              <div
                className={`w-14 h-14 mx-auto flex items-center justify-center rounded-2xl text-2xl ${modalType === "success"
                  ? "bg-green-500/20"
                  : "bg-red-500/20"
                  }`}
              >
                {modalType === "success"
                  ? "✅"
                  : "⚠️"}
              </div>

              <h2
                className={`mt-4 text-lg font-extrabold ${modalType === "success"
                  ? "text-green-400"
                  : "text-red-400"
                  }`}
              >
                {modalMessage}
              </h2>

              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="w-full mt-6 px-4 py-3 rounded-2xl bg-white text-black font-extrabold"
              >
                Entendido
              </button>
            </motion.div>
          </div>
        )}

        <p className="text-center text-xs italic text-gray-500">
          Hoy pedaleas por tu mejor versión 🚴‍♂️🔥
        </p>
      </div>
    </div>
  );
}

export default Home;